<template>
  <div id="login-wrap">
    <div class="container">
      <div class="header">
        <p>车家·寻车</p>
        <p>手机登录后自动注册</p>
      </div>
      <div class="main" ref="main">
        <p>手机号码</p>
        <div class="item item-phone">
          <div><img src="../assets/image/Vcar_Login/icon-phone.png"></div>
          <input type="tel" v-model="mobile" placeholder="请填写手机号码" maxlength="11" @blur="blur">
        </div>
        <p>验证码</p>
        <div class="item item-vcode">
          <div><img src="../assets/image/Vcar_Login/icon-vcode.png"></div>
          <input type="tel" placeholder="请填写验证码" v-model="vCode" maxlength="6" @blur="blur">
          <div><button @click="getCode" v-html="vCodeStr"></button></div>
        </div>
      </div>
      <div class="footer">
        <button @click="login">登录</button>
        <div class="version">Ver:{{version}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import common from '../utils/common'
  import constants from '../utils/constants'

    export default {
      name: "Vcar_Login",
      data(){
        return {
          version: '1.0.2',
          mobile: null,
          vCode: null,
          vCodeStr: '获取验证码',
        }
      },
      created(){
      },
      mounted(){
        window.scrollTo(0, 0)
        const vm = this
        vm.$nextTick(function () {
          /* 微信分享 */
          common.wxShare(vm, constants.VC_SHAREINFO)
        })
      },
      methods: {
        /* ios页面回落 */
        blur(e) {
          common.blurPageScroll()
        },

        // 获取验证码
        getCode(e) {
          const vm = this
          common.getVCodeAdmin(vm, e)
        },

        /* 登录 */
        login(){
          const that = this
          if(common.isEmpty(common.trimAll(that.mobile))) {
            common.tipToast('请输入手机号码')
            return
          }
          if(common.trimAll(that.mobile).length != 11) {
            common.tipToast('手机号码格式不正确')
            return
          }
          if(common.isEmpty(common.trimAll(that.vCode))) {
            common.tipToast('请输入验证码')
            return
          }
          if(common.trimAll(that.vCode).length != 6 && common.trimAll(that.vCode).length != 4) {
            common.tipToast('验证码格式不正确')
            return
          }
          const grant_type = 'mobile';
          let data = {mobile: 'SMS@' + that.mobile, code: that.vCode, grant_type}
          that.$axios({
            method: 'post',
            url: '/auth/mobile/token/sms',
            params:  data,
            headers: {
              'Authorization': 'Basic Y2pfdmhfdm1faDU6Y2hlamlhaXQyMDIwMTAwMQ',
            },
          }).then(function (res) {
            sessionStorage.setItem("access_token",res.data.access_token)
            sessionStorage.setItem("username", res.data.username)
            sessionStorage.setItem("mobile", that.mobile)
            that.$axios({
              method: 'get',
              url: '/admin/user/info',
              headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
              },
            }).then(function (res) {
              if (common.isEmpty(res.data.data.sysUser.name)) {
                sessionStorage.setItem('customerName', '用户' + sessionStorage.getItem('mobile').slice(5, 11))
              } else {
                sessionStorage.setItem("customerName", res.data.data.sysUser.name)
              }
              /*员工直接跳过*/
              if (res.data.data.userType == 1) {
                sessionStorage.setItem('userInfoFlag', true)
                common.redirect(that, 'vcar_list')
                return
              }
              /*客户已填写，直接跳过*/
              if (res.data.data.userType == 2) {
                if (!common.isEmpty(res.data.data.sysUser.company)) {
                  sessionStorage.setItem('userInfoFlag', true)
                  common.redirect(that, 'vcar_list')
                  return
                }else{
                  common.redirect(that, 'vcar_personalinformation')
                  return
                }
              }
            }).catch(function (error) {
              common.tipToast(that, "error.data.msg")
              return
            })
          }).catch(function (error) {
            common.tipToast(that, "error.data.msg")
            return
          })
        }
      }
  }
</script>

<style scoped>
  p,div,sup {
    font-family: "PingFang SC";
  }

  #login-wrap {
    width: 100vw;
    background-color: #fff;
  }

  .container {
    margin: 0 auto;
    width: 7.5rem;
    /*height: 100vh;*/
  }

  #login-wrap > .container {
    margin: 0 auto;
    width: 7.5rem;
  }

  .container > .header {
    margin: 0 auto;
    margin-top: 1.08rem;
    width: 5.655rem;
  }

  .container > .header > p {
    margin: 0;
    font-size: 0.80rem;
    line-height: 1.12rem;
    font-weight: 600;
    color: #000000;
    letter-spacing: -0px;
  }

  .container > .header > p:last-child {
    margin-top: 0.03rem;
    font-size: 0.3rem;
    font-weight: normal;
    color: #000000;
    line-height: 0.42rem;
    letter-spacing: -0px;
    opacity: 0.4;
  }

  .container > .main {
    /*border: 1px solid blue;*/
    margin: 0 auto;
    margin-top: 1.135rem;
    width: 5.655rem;
  }

  .main > p {
    margin: 0;
    margin-top: 0.89rem;
    font-size: 0.40rem;
    font-weight: 500;
    line-height: 0.56rem;
    color: #000000;
    letter-spacing: -0px;
  }

  .main > p:first-child {
    margin-top: 0;
  }

  .main > .item {
    position: relative;
    margin-top: 0.2rem;
    border-bottom: 0.01rem solid #979797;
    width: 5.655rem;
    height: 0.82rem;
    font-size: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .main > .item > div:first-child {
    position: absolute;
    top:0;
    left: 0;
    width: 0.65rem;
    height: 0.82rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .main > .item > div:first-child > img {
    width: 0.25rem;
    height: 0.38rem;
  }

  .main > .item:last-child > div > img {
    width: 0.22rem;
    height: 0.36rem;
  }

  .main > .item > input {
    padding: 0;
    padding-left: 0.92rem;
    width: 100%;
    height: 0.78rem;
    line-height: 0.36rem;
    border: 0;
    font-size: 0.30rem;
    color: #000000;
    letter-spacing: -0px;
    outline: none;
    text-align: left;
  }

  .main > .item > input:last-child {
    padding-right: 2rem;
  }

  .main > .item > div:last-child{
    position: absolute;
    top: 0;
    right: 0;
    height: 0.82rem;
    display: flex;
    align-items: center;
  }
  .main > .item > div:last-child > button {

    margin: 0 auto;
    /*padding: 0.1rem 0.16rem;*/
    min-width: 1.62rem;
    height: 0.58rem;
    display: block;
    background-image: linear-gradient(90deg, #195EDB 0%, #2594FE 100%);
    border-radius: 0.28rem;
    border-width: 0;
    outline: none;
    font-size: 0.26rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    text-align: center;
    white-space: nowrap;
  }

  .container > .footer {
    margin-top: 1.485rem;
    width: 100%;
    text-align: center;
  }

  .container > .footer > button {
    margin: 0 auto;
    padding: 0;
    width: 5.80rem;
    height: 1rem;
    display: block;
    background-image: linear-gradient(90deg, #195EDB 0%, #2594FE 100%);
    border-radius: 0.5rem;
    border-width: 0;
    outline: none;
    font-size: 0.32rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    text-align: center;
  }
  .version {
    margin-top: 1.5rem;
    padding-bottom: 0.3rem;
    width: 100%;
    font-size: 0.28rem;
    color: #000;
    text-align: center;
    z-index: 4;
  }

</style>



// WEBPACK FOOTER //
// src/components/Vcar_Login.vue